import { VortexUICurrentAttempt } from "../components/ui/hud/VortexUI";

export var globals = {
	showDebugForComponents: false,
	showDebugAnswerTypes: false,
	isMuted: false,
    memory: '',
    queryMemory: false,
	worldScale: 0,
	vortexAttempts: ([] as VortexUICurrentAttempt[])
};